import { useCallback } from "react";
import { FiLink, FiLink2 } from "react-icons/fi";
import { FormattedMessage } from "react-intl";
import { connect, useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  EyeClose,
  EyeOpen,
  InstagramIcon,
  PencilIcon,
  PinterestIcon,
  SnapchatIcon,
  TikTokIcon,
  TwitterIcon,
  WebsiteIcon,
  YoutubeIcon,
} from "../../icons/Icons";
import { buildNetworkLink } from "../../tools/functions";
import Avatar from "../cmp/Avatar";
import CardColumns from "../cmp/CardColumns";
import useToggle from "../cmp/hooks/useToggle";
import FormattedHelmet from "../cmp/intl/FormattedHelmet";
import RenderHTMLWithScript from "../cmp/RenderHTMLWithScript";
import ShareBar from "../cmp/ShareBar";
import ShopifyMultipassLogin from "../cmp/ShopifyMultipassLogin";
import { RenderCustomLeaderboard } from "./analytics/custom-leaderboards/RenderCustomLeaderboard";
import Leaderboard from "./analytics/Leaderboard";
import ProductLeaderboard from "./analytics/ProductLeaderboard";
import ReferralSources from "./analytics/ReferralSources";
import TopProductsAnalytics from "./analytics/TopProductsAnalytics";
import CouponRef from "./cmp/CouponRef";
import ProductCommissionsTableNew from "./commissions/ProductCommissionsTableNew";
import CompensationPlansRender from "./compensation-plan/CompensationPlansRender";
import ConnectedCustomersWidget from "./connected-customers/ConnectedCustomersWidget";
import FreeGiftList from "./free-gift/FreeGiftList";
import AffiliateSalesSection from "./home/AffiliateSalesSection";
import LazyAffiliateSaleDetails from "./home/lazy/LazyAffiliateSaleDetails";
import PersonalDiscount from "./home/PersonalDiscount";
import QuickLinks from "./home/QuickLinks";
import ReferralLink from "./home/ReferralLink";
import MLMCommissionsTable from "./mlm/MLMCommissionsTable";
import mustache from "mustache";

function Home({
  name,
  email,
  twitter,
  snapchat,
  pinterest,
  tiktok,
  instagram,
  partner_website,
  company_name,
  youtube,
  profile_photo,
  badges,
  ref_tracking_enabled,
  coupon_tracking_enabled,
  mlm_enabled,
  link_type,
  status,
  affiliate_shop_domain,
  ref_code,
  show_coupon_codes,
  personal_coupon,
  personal_message,
  mlm_tree,
  reflink_instructions,
  network_link_page,
  partner_portal_subdomain,
  aff_show_connected_customers,
  aff_show_leaderboard,
  aff_show_visit_source,
  aff_show_top_products,
  aff_show_product_leaderboard,
  aff_show_order_details,
  aff_network_link_show,
  aff_network_commissions_show,
  aff_show_product_commissions,
  hide_coupon_section_if_empty,
  my_coupons,
}) {
  const [showLinks, toggleLinks] = useToggle(true);
  const custom_leaderboards = useSelector(
    (state) => state.settings.custom_leaderboards,
  );
  return (
    <>
      <FormattedHelmet id={"navlinkHome"} />
      <div className={"row justify-content-between"}>
        {profile_photo && profile_photo.value && profile_photo.value.url && (
          <Avatar url={profile_photo.value.url} />
        )}
        <div className={"col"}>
          <div className={"d-flex align-items-center"}>
            <div>
              <h2>{name}</h2>
              {company_name && <div>{company_name}</div>}
            </div>
            {badges &&
              badges.slice(0, 1).map((url) => {
                return (
                  <img
                    src={url}
                    height={48}
                    className={"affiliate_badge mx-2"}
                    alt={"Badge"}
                  />
                );
              })}
          </div>
          <small>{email}</small>
          <ShopifyMultipassLogin />
          <p>
            {twitter && <TwitterIcon className={"mr-2 text-muted"} />}
            {instagram && <InstagramIcon className={"mr-2 text-muted"} />}
            {partner_website && <WebsiteIcon className={"mr-2 text-muted"} />}
            {youtube && <YoutubeIcon className={"mr-2 text-muted"} />}
            {tiktok && (
              <TikTokIcon height={"0.95em"} className={"mr-2 text-muted"} />
            )}
            {snapchat && <SnapchatIcon className={"mr-2 text-muted"} />}
            {pinterest && <PinterestIcon className={"mr-2 text-muted"} />}
          </p>
        </div>
        {ref_tracking_enabled || coupon_tracking_enabled || mlm_enabled ? (
          <div className={"col-auto privacy_button_group"}>
            <div>
              <PrivacyMode />
              <button className={"btn hide-links-button"} onClick={toggleLinks}>
                {showLinks ? <FiLink2 /> : <FiLink />}
              </button>
            </div>
          </div>
        ) : null}
      </div>
      {showLinks && (
        <div className="py-2">
          <div className={"row mb-2"}>
            {ref_tracking_enabled && link_type !== -1 ? (
              <div className="col-md">
                {ref_tracking_enabled && link_type !== -1 && (
                  <ReferralLink status={status} />
                )}
              </div>
            ) : null}
            {affiliate_shop_domain && (
              <div className={"col-md mb-4"}>
                <AffiliateStore
                  affiliate_shop_domain={affiliate_shop_domain}
                  ref_code={ref_code}
                />
              </div>
            )}
            {coupon_tracking_enabled &&
              show_coupon_codes &&
              !(hide_coupon_section_if_empty && my_coupons.length === 0) && (
                <div className="col-md mb-4">
                  <CouponRef />
                </div>
              )}
            {personal_coupon && personal_coupon.length > 0 && (
              <div className={"col-md"}>
                <PersonalDiscount />
              </div>
            )}
          </div>
          <PersonalMessage />
          <ReflinkInstructions />
          <QuickLinks />
          {mlm_enabled &&
            (aff_network_link_show || aff_network_commissions_show) && (
              <div className={"py-4"}>
                <div className="row">
                  {aff_network_link_show && (
                    <div className="col-md">
                      <NetworkLink
                        network_link_page={network_link_page}
                        partner_portal_subdomain={partner_portal_subdomain}
                        ref_code={ref_code}
                      />
                    </div>
                  )}
                  {aff_network_commissions_show && (
                    <div className="col-md">
                      <h4>
                        <FormattedMessage id={"Network Commissions"} />
                      </h4>
                      <p className={"text-muted"}>
                        <FormattedMessage id={"networkCommissionDescription"} />
                      </p>
                      <MLMCommissionsTable mlm_tree={mlm_tree} />
                    </div>
                  )}
                </div>
              </div>
            )}
        </div>
      )}
      <FreeGift />
      {aff_show_product_commissions && (
        <div className="py-2 border-bottom">
          <div className="d-flex justify-content-between align-items-center">
            <h4>
              <FormattedMessage id={"Commission Structure"} />
            </h4>
          </div>
          <ProductCommissionsTableNew />
        </div>
      )}
      <div className="home-sales-data">
        <div>
          <CompensationPlansRender />
        </div>
        <AffiliateSalesSection />
      </div>
      <CardColumns>
        {aff_show_leaderboard ? <Leaderboard /> : undefined}
        {custom_leaderboards && custom_leaderboards.length > 0
          ? custom_leaderboards.map((i) => {
              return (
                <RenderCustomLeaderboard
                  timePeriodX={i.timePeriodX}
                  headerBg={i.headerBg}
                  headerColor={i.headerColor}
                  startDate={i.startDate}
                  endDate={i.endDate}
                  key={i.id}
                  id={i.id}
                  timePeriod={i.timePeriod}
                  name={i.name}
                  {...i}
                />
              );
            })
          : undefined}
        {aff_show_product_leaderboard ? <ProductLeaderboard /> : undefined}
        {aff_show_visit_source ? <ReferralSources /> : undefined}
        {aff_show_top_products ? <TopProductsAnalytics /> : undefined}
        {aff_show_connected_customers ? (
          <ConnectedCustomersWidget mode={"home"} />
        ) : undefined}
      </CardColumns>
      {aff_show_order_details && (
        <div className="mt-4">
          <LazyAffiliateSaleDetails />
        </div>
      )}
    </>
  );
}
function PersonalMessage() {
  const personal_message = useSelector(
    (state) => state.settings.personal_message,
  );
  const settings = useSelector((state) => state.settings);
  if (!personal_message) {
    return null;
  }
  return (
    <p
      className={"alert alert-info"}
      style={{ whiteSpace: "pre-line" }}
      dangerouslySetInnerHTML={{ __html: mustache.render(personal_message, settings) }}
    />
  );
}

function ReflinkInstructions() {
  const reflink_instructions = useSelector(
    (state) => state.settings.reflink_instructions,
  );
  if (!reflink_instructions) return null;
  return (
    <div>
      {reflink_instructions.includes("script") ? (
        <RenderHTMLWithScript html={reflink_instructions} />
      ) : (
        <div dangerouslySetInnerHTML={{ __html: reflink_instructions }} />
      )}
    </div>
  );
}

function FreeGift() {
  const availableGifts = useSelector((state) => state.settings.gifts);
  if (!availableGifts || availableGifts.length === 0) return null;
  return (
    <div>
      <h4>
        <FormattedMessage id={"Gifts"} />
      </h4>
      <div>
        <FormattedMessage id={"gift_subtitle"} defaultMessage={" "} />
      </div>
      <FreeGiftList />
    </div>
  );
}

function NetworkLink({
  network_link_page,
  partner_portal_subdomain,
  ref_code,
}) {
  const { homepage, signup_page } = buildNetworkLink(
    network_link_page,
    partner_portal_subdomain,
    ref_code,
  );
  if (!network_link_page) {
    const homePage = homepage;
    const referral_link = signup_page;
    return (
      <div>
        <h4>
          <FormattedMessage
            id={"networkLink"}
            defaultMessage={"Network Link"}
          />
        </h4>
        <p className={"text-muted"}>
          <FormattedMessage
            id={"Invite others, grow your network, and earn commissions"}
          />
        </p>
        {/* <strong>
          <FormattedMessage id={"Signup Link"} />
        </strong> */}
        <p>
          <a
            href={referral_link}
            target={"_blank"}
            title={"Referral Link"}
            className={"d-block"}
          >
            {referral_link}
          </a>
        </p>
        <ShareBar link={referral_link} />
        {/* <hr/>
        <strong><FormattedMessage id={'Home Page'}/></strong>
        <p>
          <CopyButton text={homePage} title={homePage}
                      className={"px-0 btn btn-link"}/>
        </p> */}
      </div>
    );
  } else {
    const homePage = homepage;
    return (
      <div>
        <h4>
          <FormattedMessage
            id={"networkLink"}
            defaultMessage={"Network Link"}
          />
        </h4>
        <p className={"text-muted"}>
          <FormattedMessage
            id={"Invite others, grow your network, and earn commissions"}
          />
        </p>
        <strong>
          <FormattedMessage id={"Signup Link"} />
        </strong>
        <p>
          <a
            href={homePage}
            target={"_blank"}
            title={"Referral Link"}
            className={"d-block"}
          >
            {homePage}
          </a>
        </p>
        <ShareBar link={homePage} />
      </div>
    );
  }
}

function AffiliateStore({ affiliate_shop_domain, ref_code }) {
  if (!affiliate_shop_domain) {
    return null;
  }
  return (
    <div>
      <div className="d-flex align-items-center justify-content-between">
        <FormattedMessage tagName={"h4"} id={"Shop"} />
        <Link className={"btn text-muted"} to={"/edit-shop"}>
          <PencilIcon />
        </Link>
      </div>
      <p className={"text-muted shop-description"}>
        <FormattedMessage id={"referralLinkDesc"} />
      </p>
      <p>
        <a
          className={"shop-link"}
          href={`https://${affiliate_shop_domain}/${ref_code}`}
          target={"_blank"}
        >{`https://${affiliate_shop_domain}/${ref_code}`}</a>
      </p>
      <div className="d-flex align-items-center justify-content-between">
        <ShareBar link={`https://${affiliate_shop_domain}/${ref_code}`} />
      </div>
    </div>
  );
}

function PrivacyMode() {
  const privacyMode = useSelector((state) => state.settings.privacyMode);
  const dispatch = useDispatch();
  const click = useCallback(() => {
    console.log("action dispatched", !privacyMode);
    const c = !privacyMode;
    try {
      if (c) {
        sessionStorage.setItem("privacyMode", "1");
      } else {
        sessionStorage.removeItem("privacyMode");
      }
    } catch (e) {}
    dispatch({
      type: "merge-settings",
      settings: {
        privacyMode: !privacyMode,
      },
    });
  }, [dispatch, privacyMode]);
  return (
    <button onClick={click} className={"btn"}>
      {privacyMode ? <EyeClose /> : <EyeOpen />}
    </button>
  );
}

const mapStateToProps = (state) => {
  const {
    network_link_page,
    personal_message,
    reflink_instructions,
    is_redirect,
    signup_data,
    show_coupon_codes,
    affiliate_shop_domain,
    hide_coupon_section_if_empty,
    my_coupons,
    badges,
  } = state.settings;
  const link_type = Number(is_redirect);
  const sgnupdata = signup_data
    ? typeof signup_data === "object"
      ? signup_data
      : JSON.parse(signup_data)
    : [];
  const profile_photo = sgnupdata["profile_photo"];
  return {
    ...state.settings,
    badges,
    show_coupon_codes,
    network_link_page,
    link_type, // 1 = redirect, 0 = normal referral link, -1 = referral link is disabled
    aff_show_product_commissions: state.settings.aff_show_product_commissions,
    aff_network_link_show:
      state.settings.aff_network_link_show === undefined
        ? true
        : state.settings.aff_network_link_show,
    aff_network_commissions_show:
      state.settings.aff_network_commissions_show === undefined
        ? true
        : state.settings.aff_network_commissions_show,
    status: state.settings.status,
    mlm_tree: state.settings.mlm_tree && JSON.parse(state.settings.mlm_tree),
    coupon_tracking_enabled:
      state.settings.coupon_tracking_enabled === undefined
        ? true
        : state.settings.coupon_tracking_enabled,
    ref_tracking_enabled:
      state.settings.ref_tracking_enabled === undefined
        ? true
        : state.settings.ref_tracking_enabled,
    reflink_instructions,
    personal_message,
    profile_photo,
    affiliate_shop_domain,
    hide_coupon_section_if_empty,
    my_coupons,
  };
};

export default connect(mapStateToProps)(Home);
